import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoggingService } from '@services/logging/logging.module';
import { DashboardSupportGuard } from '@shared/guards/dashboard-support-guard';
import { SupportFirstDashboardGuard } from '@shared/guards/dashboard-support-first-guard';
import { EngageRedirectGuard } from '@shared/guards/engage-redirect-guard';
import { AuthService } from '@shared/services/auth/auth.service';
import { MenuService } from '../core/menu/menu.service';
import { TranslatorService } from '../core/translator/translator.service';
import { HttpErrorHandler } from '../shared/http-error-handler.service';
import { MessageService } from '../shared/message.service';
import { SharedModule } from '../shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { routes } from './routes';

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
        PagesModule
    ],
    declarations: [],
    exports: [
        RouterModule
    ],
    providers: [
        AuthService,
        HttpErrorHandler,
        MessageService,
        DashboardSupportGuard,
        SupportFirstDashboardGuard,
        EngageRedirectGuard,
    ]
})

export class RoutesModule {
    constructor(public menuService: MenuService, tr: TranslatorService, logging: LoggingService) {
        logging.log.info('RoutesModule', 'done');
    }
}
